'use strict';

var creditCardType = require('credit-card-type');

creditCardType.removeCard(creditCardType.types.MIR);

module.exports = creditCardType;



//////////////////
// WEBPACK FOOTER
// ./node_modules/braintree-web/hosted-fields/shared/get-card-types.js
// module id = 500
// module chunks = 0